module.exports = __webpack_public_path__ + "img/shiba-body-level2.f6600311.png";